var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSelfSufficiency = function SvgSelfSufficiency(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.264 4.707a5.002 5.002 0 0 0-8.737 2.768.667.667 0 0 1-1.326-.14 6.335 6.335 0 0 1 11.253-3.28l.073-.272a.667.667 0 0 1 1.288.346l-.488 1.821a.667.667 0 0 1-.817.471l-1.821-.488a.667.667 0 0 1 .345-1.288zm1.942 3.225a.667.667 0 0 1 .592.734 6.335 6.335 0 0 1-11.253 3.28l-.072.27a.667.667 0 1 1-1.288-.344l.488-1.822a.667.667 0 0 1 .816-.471l1.822.488a.667.667 0 1 1-.345 1.288l-.23-.062a5.002 5.002 0 0 0 8.736-2.768.667.667 0 0 1 .734-.593",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.602 5.417a.667.667 0 0 1 .259.907L8.3 7.334h1.533a.667.667 0 0 1 .583.99l-1.111 2a.667.667 0 1 1-1.166-.648l.561-1.01H7.167a.667.667 0 0 1-.583-.99l1.111-2a.667.667 0 0 1 .907-.259"
  })));
};
export default SvgSelfSufficiency;